import { createApi } from '@reduxjs/toolkit/query/react';
import { customBaseQuery } from '../utils';
import { TAsset, TChangeAsset, TCreateAsset } from '../../config/requestTypes';

export const admin = createApi({
  reducerPath: 'admin',
  baseQuery: customBaseQuery,
  tagTypes: ['AssetsList'],
  endpoints: (builder) => ({
    getAssets: builder.query<any, { type: string }>({
      query: ({ type }) => ({
        url: '/assets',
        method: 'GET',
        params: { type },
      }),
      providesTags: ['AssetsList'],
    }),

    changeAsset: builder.mutation<any, { id: string; data: TChangeAsset }>({
      query: ({ id, data }) => {
        const formData = new FormData();
        // Add all fields to FormData
        if (data.title) formData.append('title', data.title);
        if (data.subtitle) formData.append('subtitle', data.subtitle);
        if (data.description) formData.append('description', data.description);
        if (data.isHidden !== undefined)
          formData.append('isHidden', String(data.isHidden));
        if (data.commissionPercent !== undefined)
          formData.append('commissionPercent', String(data.commissionPercent));
        if (data.decimalPlaces !== undefined)
          formData.append('decimalPlaces', String(data.decimalPlaces));
        if (data.removeImage !== undefined)
          formData.append('removeImage', String(data.removeImage));

        if (data.image) {
          formData.append('image', data.image);
        }

        return {
          url: `/assets/${id}`,
          method: 'PATCH',
          body: formData, // pass FormData
        };
      },
    }),

    createAsset: builder.mutation<TAsset[], TCreateAsset>({
      query: (data: TCreateAsset) => {
        const formData = new FormData();

        Object.entries(data).forEach(([key, value]) => {
          if (value === undefined || value === null) return;

          if (value instanceof File) {
            formData.append(key, value);
          } else {
            formData.append(key, String(value));
          }
        });

        return {
          url: '/assets',
          method: 'POST',
          body: formData,
        };
      },
      invalidatesTags: ['AssetsList'],
    }),
  }),
});

export const {
  useGetAssetsQuery,
  useCreateAssetMutation,
  useChangeAssetMutation,
} = admin;
